import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * MobileBottomCTA - Sticky bottom CTA for mobile navigation
 * 
 * Calm, enterprise-grade - no urgency language
 */

interface MobileBottomCTAProps {
  visible: boolean;
}

const MobileBottomCTA = ({ visible }: MobileBottomCTAProps) => {
  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <div className="bg-background border-t border-border px-4 py-4 safe-area-pb">
        <Button 
          className="w-full" 
          size="lg"
          asChild
        >
          <Link to="/contact">
            Discuss your growth challenge
          </Link>
        </Button>
        <p className="text-xs text-muted-foreground text-center mt-2">
          Response within 1 business day
        </p>
      </div>
    </div>
  );
};

export default MobileBottomCTA;
